export const langConversionHelper = {
  languageList,
  findLanguage,
  findLanguageAbbrev,
  findLanguageID,
  dayConversion,
  dayAbbrevConversion,
  monthConversion,
  monthAbbrevConversion,
  profileConversion,
  appointmentConversion,
  paymentConversion,
  invoiceTransConversion,
  colorList,
  individualColorConversion,
  paymentSummaryFeeTransConversion,
  translateProfileKey,
  profileConversion2,
  handleLanguageChangeEffect,
};

const languages = [
  {
    langAbbrev: "en",
    nativeName: "In English",
    languageID: 1,
    displayName: "English",
  },
  {
    langAbbrev: "es",
    nativeName: "En Español",
    languageID: 2,
    displayName: "Español",
  },
];
const daysOfTheWeekTranslation = [
  { enDay: "Sunday", es: "domingo" },
  { enDay: "Monday", es: "lunes" },
  { enDay: "Tuesday", es: "martes" },
  { enDay: "Wednesday", es: "miércoles" },
  { enDay: "Thursday", es: "jueves" },
  { enDay: "Friday", es: "viernes" },
  { enDay: "Saturday", es: "sábado" },
];
const monthsOfYearTranslation = [
  { enMonth: "January", es: "enero" },
  { enMonth: "February", es: "febrero" },
  { enMonth: "March", es: "marcha" },
  { enMonth: "April", es: "abril" },
  { enMonth: "May", es: "mayo" },
  { enMonth: "June", es: "junio" },
  { enMonth: "July", es: "julio" },
  { enMonth: "August", es: "agosto" },
  { enMonth: "September", es: "septiembre" },
  { enMonth: "October", es: "octubre" },
  { enMonth: "November", es: "noviembre" },
  { enMonth: "December", es: "diciembre" },
];
const daysOfTheWeekAbbrevTranslation = [
  { enDay: "Sun", es: "dom" },
  { enDay: "Mon", es: "lun" },
  { enDay: "Tue", es: "mar" },
  { enDay: "Wed", es: "mié" },
  { enDay: "Thu", es: "jue" },
  { enDay: "Fri", es: "vie" },
  { enDay: "Sat", es: "sáb" },
];
const monthAbbrevTranslation = [
  { enMonth: "Jan", es: "ene" },
  { enMonth: "Feb", es: "feb" },
  { enMonth: "Mar", es: "mar" },
  { enMonth: "Apr", es: "abr" },
  { enMonth: "May", es: "may" },
  { enMonth: "Jun", es: "jun" },
  { enMonth: "Jul", es: "jul" },
  { enMonth: "Aug", es: "ago" },
  { enMonth: "Sep", es: "sep" },
  { enMonth: "Oct", es: "oct" },
  { enMonth: "Nov", es: "nov" },
  { enMonth: "Dec", es: "dic" },
];
const profileEditType = [
  { en: "Name", es: "Nombre" },
  { en: "Email", es: "Correo Electrónico" },
  { en: "Password", es: "Contraseña" },
  { en: "Phone", es: "Teléfono" },
  { en: "Emergency Contact", es: "Contacto de Emergencia" },
  { en: "Preferences", es: "Preferencias" },
  { en: "Language", es: "Idioma" },
  { en: "Birthday", es: "Cumpleaños" },
  { en: "Address", es: "Dirección" },
  { en: "State ID", es: "ID del Estado" },
  { en: "VIN", es: "VIN" },
  { en: "License Plate", es: "Matrícula" },
  { en: "Push Button Start", es: "Encendido por Botón" },
  { en: "Remote Start", es: "Inicio Remoto" },
];
const appointmentTypes = [
  { enType: "Installation", es: "Instalación" },
  { enType: "Calibration", es: "Calibración" },
  { enType: "Lock Out", es: "Dejar Fuera" },
  { enType: "Vehicle Switch", es: "Interruptor de Vehículo" },
  { enType: "Deinstall", es: "Desinstalar" },
  { enType: "Monitoring", es: "Escucha" },
  { enType: "Device Return", es: "Devolución del Dispositivo" },
];
const paymentTypes = [{ enType: "Recurring Fee", es: "Cobro Recurrente" }];
const invoiceTransactions = [
  { enTrans: "Online Payment", es: "Pago en línea" },
  { enTrans: "Auto Payment", es: "Pago automático" },
  { enTrans: "AutoPay Invoice", es: "Pago automático de factura" },
  { enTrans: "Service Call", es: "Llamada de servicio" },
  { enTrans: "Payment", es: "Pago" },
  { enTrans: "Service Visit", es: "Visita de servicio" },
];
const paymentSummaryFees = [
  {
    enType: "Daily Loss Protection Plan",
    es: "Plan diario de protección de pérdidas",
  },
  { enType: "Daily Monitoring FC100", es: "Monitoreo diario FC100" },
  { enType: "Early Service Fee", es: "Cargo por servicio anticipado" },
  { enType: "Expedient Shipping Fee", es: "Tarifa de envío conveniente" },
  { enType: "Reset/Violation Reset", es: "Restablecer/Restablecer infracción" },
  { enType: "Reporting Fee", es: "Cuota de informe" },
];
const colorNames = [
  {
    en: "Black",
    es: "Negro",
    pt: "Preto",
    fi: "Musta",
    fr: "Noir",
    de: "Schwarz",
    sv: "Svart",
    nl: "Zwart",
  },
  {
    en: "Blue",
    es: "Azul",
    pt: "Azul",
    fi: "Sininen",
    fr: "Bleu",
    de: "Blau",
    sv: "Blå",
    nl: "Blauw",
  },
  {
    en: "Brown",
    es: "Marrón",
    pt: "Marrom",
    fi: "Ruskea",
    fr: "Brun",
    de: "Braun",
    sv: "Brun",
    nl: "Bruin",
  },
  {
    en: "Gold",
    es: "Oro",
    pt: "Ouro",
    fi: "Kulta",
    fr: "Or",
    de: "Gold",
    sv: "Guld",
    nl: "Goud",
  },
  {
    en: "Gray",
    es: "Gris",
    pt: "Cinza",
    fi: "Harmaa",
    fr: "Gris",
    de: "Grau",
    sv: "Grå",
    nl: "Grijs",
  },
  {
    en: "Green",
    es: "Verde",
    pt: "Verde",
    fi: "Vihreä",
    fr: "Vert",
    de: "Grün",
    sv: "Grön",
    nl: "Groente",
  },
  {
    en: "Orange",
    es: "Naranja",
    pt: "Laranja",
    fi: "Oranssi",
    fr: "Orange",
    de: "Orange",
    sv: "Orange",
    nl: "Oranje",
  },
  {
    en: "Purple",
    es: "Morado",
    pt: "Roxo",
    fi: "Violetti",
    fr: "Violet",
    de: "Lila",
    sv: "Lila",
    nl: "Paars",
  },
  {
    en: "Red",
    es: "Rojo",
    pt: "Vermelho",
    fi: "Punainen",
    fr: "Rouge",
    de: "Rot",
    sv: "Röd",
    nl: "Rood",
  },
  {
    en: "Silver",
    es: "Plata",
    pt: "Prata",
    fi: "Hopea",
    fr: "Argent",
    de: "Silber",
    sv: "Silver",
    nl: "Zilver",
  },
  {
    en: "White",
    es: "Blanco",
    pt: "Branco",
    fi: "Valkoinen",
    fr: "Blanc",
    de: "Weiß",
    sv: "Vit",
    nl: "Wit",
  },
  {
    en: "Yellow",
    es: "Amarillo",
    pt: "Amarelo",
    fi: "Keltainen",
    fr: "Jaune",
    de: "Gelb",
    sv: "Gul",
    nl: "Geel",
  },
];

//Language Options
function languageList() {
  return languages;
}
function findLanguage(languageID) {
  let obj = languages.find((x) => x.languageID === languageID);

  if (obj === undefined) return "";
  else {
    if (
      obj.displayName !== null &&
      obj.displayName != "" &&
      obj.displayName !== undefined
    )
      return obj.displayName;
    else return "";
  }
}
function findLanguageAbbrev(languageID) {
  let obj = languages.find((x) => x.languageID === languageID);
  if (obj === undefined) return "en";
  else {
    if (
      obj.langAbbrev !== null &&
      obj.langAbbrev != "" &&
      obj.langAbbrev !== undefined
    )
      return obj.langAbbrev;
    else return "en";
  }
}
function findLanguageID(langAbbrev) {
  let obj = languages.find((x) => x.langAbbrev === langAbbrev);
  if (obj === undefined) return 1;
  else {
    if (
      obj.languageID !== null &&
      obj.languageID != "" &&
      obj.languageID !== undefined
    )
      return obj.languageID;
    else return "en";
  }
}

//If for any reason the conversion can't happen return the English version
function dayConversion(day, transLang) {
  let obj = daysOfTheWeekTranslation.find((x) => x.enDay === day);
  return propertyCheck(obj, transLang, day);
}
function dayAbbrevConversion(day, transLang) {
  let obj = daysOfTheWeekAbbrevTranslation.find((x) => x.enDay === day);
  return propertyCheck(obj, transLang, day);
}
function monthConversion(month, transLang) {
  let obj = monthsOfYearTranslation.find((x) => x.enMonth === month);
  return propertyCheck(obj, transLang, month);
}
function monthAbbrevConversion(month, transLang) {
  let obj = monthAbbrevTranslation.find((x) => x.enMonth === month);
  return propertyCheck(obj, transLang, month);
}
function profileConversion(editType, transLang) {
  let obj = profileEditType.find((x) => x[transLang] === editType);
  if (obj === undefined) return editType;
  else return obj.en;
}

//Added By Ankit Luitel Calling using editType
export function profileConversion2(editType) {
  if (!editType || !Array.isArray(profileEditType)) {
    return editType;
  }
  const obj = profileEditType.find(x =>
    Object.values(x).includes(editType)
  );
  return obj ? obj.en : editType;
}


export function translateProfileKey(englishKey, lang) {
  const obj = profileEditType.find(x => x.en === englishKey);
  return obj ? (obj[lang] || englishKey) : englishKey;
}
function appointmentConversion(apptType, transLang) {
  let obj = appointmentTypes.find((x) => x.enType === apptType);
  return propertyCheck(obj, transLang, apptType);
}
function paymentConversion(paymentType, transLang) {
  let obj = paymentTypes.find((x) => x.enType === paymentType);
  return propertyCheck(obj, transLang, paymentType);
}
function invoiceTransConversion(invTrans, transLang) {
  let obj = invoiceTransactions.find((x) => x.enTrans === invTrans);
  return propertyCheck(obj, transLang, invTrans);
}
function paymentSummaryFeeTransConversion(fee, transLang) {
  let obj = paymentSummaryFees.find((x) => x.enType === fee);
  return propertyCheck(obj, transLang, fee);
}

// Property Helper to ensure key exists & the ensure value is not null, empty, or undefined
function propertyCheck(obj, key, original) {
  if (obj === undefined || !(key in obj)) return original;
  else {
    if (obj[key] !== null && obj[key] != "" && obj[key] !== undefined)
      return obj[key];
    else return original;
  }
}

function colorList(languageId) {
  let colorArray = colorNames.map((colorName) => ({
    label: colorName[languageId],
    code: colorName.en,
  }));
  colorArray.sort((a, b) => a.label.localeCompare(b.label));
  return colorArray;
}
function individualColorConversion(color, transLang) {
  let obj = colorNames.find((x) => x.en.toLowerCase() === color.toLowerCase());
  if (obj === undefined || !(transLang in obj)) return "";
  else {
    if (
      obj[transLang] !== null &&
      obj[transLang] != "" &&
      obj[transLang] !== undefined
    )
      return obj[transLang];
    else return "";
  }
}

//Added By Ankit Luitel Calling for changing language when edit button is not clicked
function handleLanguageChangeEffect({
  didMountRef,
  editItem,
  i18n,
  baseEnglishKey,
  setBaseEnglishKey,
  setLanguageConvert,
  setEditItem,
  langConversionHelper
}) {
  if (!didMountRef?.current) {
    if (didMountRef) didMountRef.current = true;
    return;
  }

  if (!editItem || !i18n?.language || !langConversionHelper) return;

  let englishKeyToUse = baseEnglishKey;

  if (!baseEnglishKey) {
    if (typeof langConversionHelper.profileConversion2 === 'function') {
      englishKeyToUse = langConversionHelper.profileConversion2(editItem);
      setBaseEnglishKey?.(englishKeyToUse);
    }
  }

  if (typeof langConversionHelper.translateProfileKey === 'function') {
    const translated = langConversionHelper.translateProfileKey(englishKeyToUse, i18n.language);
    setLanguageConvert?.(translated);
    setEditItem?.(englishKeyToUse);
  }
}

